import Product from './Product';

export default class ProductCOA {
    id: string;

    // The METRC Batch number to search
    title: string;

    // The product the COA is for
    product: Product;

    // PDF File from the COA report
    pdf_file: string;

    created_on: Date;
}
